var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4A460"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9787 25.2446V30.9535C16.9787 31.1306 17.0495 31.3004 17.1756 31.4257C17.3016 31.5509 17.4726 31.6212 17.6509 31.6212H29.7492C29.9274 31.6212 30.0984 31.5509 30.2244 31.4257C30.3505 31.3004 30.4213 31.1306 30.4213 30.9535V25.2446",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4563 16.8H29.9438C30.0902 16.8012 30.2324 16.8487 30.3493 16.9355C30.4663 17.0222 30.5519 17.1437 30.5934 17.282L31.8 21.4532H15.6L16.8066 17.282C16.8481 17.1437 16.9337 17.0222 17.0507 16.9355C17.1677 16.8487 17.3098 16.8012 17.4563 16.8V16.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9426 21.4531V22.8318C20.9426 23.5632 20.6611 24.2645 20.1602 24.7817C19.6592 25.2988 18.9797 25.5893 18.2713 25.5893C17.5628 25.5893 16.8834 25.2988 16.3824 24.7817C15.8814 24.2645 15.6 23.5632 15.6 22.8318V21.4531",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4575 21.4531V22.8318C26.4575 23.5632 26.1669 24.2645 25.6498 24.7817C25.1327 25.2988 24.4313 25.5893 23.7 25.5893C22.9687 25.5893 22.2673 25.2988 21.7502 24.7817C21.2331 24.2645 20.9426 23.5632 20.9426 22.8318V21.4531",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 21.4531V22.8318C31.8 23.5632 31.5186 24.2645 31.0176 24.7817C30.5167 25.2988 29.8372 25.5893 29.1287 25.5893C28.4203 25.5893 27.7408 25.2988 27.2399 24.7817C26.7389 24.2645 26.4575 23.5632 26.4575 22.8318V21.4531",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.6d338d861babae1eef6033d854403e1f.svg";
export { ForwardRef as ReactComponent };